import * as THREE from 'three';

import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import EventDispatcher from './EventDispatcher';
import Global from './Global';
import orientationControl from 'three.orientation';
import { isMobile } from 'mobile-device-detect';

window.THREE = THREE;
export default class Control extends OrbitControls {
  constructor(camera, canvas) {
    super(camera, canvas);

    this.camera = camera;
  }
  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));

    this.oAlpha = 0;
    this.oBeta = 0;
    this.oGamma = 0;

    this.screenSpacePanning = false;
    this.enableDamping = true;
    this.rotateSpeed = 0.5;
    this.dampingFactor = 0.08;
    this.enableZoom = false;
    this.minDistance = 0.1;
    this.maxDistance = 0.2;

    this.target.copy(new THREE.Vector3(-0.0005, -0.0005, -0.005));
    this.minPolarAngle = Math.PI * 0.2;
    this.maxPolarAngle = Math.PI * 0.8;

    this.enablePan = false;
    this.enableRotate = false;
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'update':
        this.gameUpdate();
        break;
      case 'gyro_permission_update':
        this.onGyroPermissionUpdated();
        break;
      case 'remove_control':
        this.stopControl();
        break;
      case 'add_control':
        this.startControl();
        break;
      case 'disable_control':
        this.enabled = false;
        break;
      case 'enable_control':
        this.enabled = true;
        break;
    }
  }
  stopControl() {
    this.enabled = false;
  }
  startControl(levelIndex) {
    if (levelIndex === 1) {
      this.target.copy(new THREE.Vector3(-0.0005, -0.0005, -0.005));
      this.minPolarAngle = Math.PI * 0.2;
      this.maxPolarAngle = Math.PI * 0.8;
    }
    this.enabled = true;
  }
  gameUpdate() {
    if (Global.clockStopped) return false;
    if (Global.deviceOrientationAvailable && isMobile && Global.isGyroActive) {
      this.deviceControl && this.deviceControl.update();
    } else {
      // this.update();
    }
    // this.update();
  }
  onGyroPermissionUpdated() {
    if (Global.deviceOrientationAvailable && isMobile) {
      this.deviceControl = orientationControl(this.camera);
    }
  }
  /*  handleOrientation(event){
        this.oAlpha = THREE.MathUtils.degToRad(event.alpha); // Rotation around Z-axis
        this.oBeta = THREE.MathUtils.degToRad(event.beta);   // Rotation around X-axis
        this.oGamma = THREE.MathUtils.degToRad(event.gamma); // Rotation around Y-axis
    } */
}
